// extracted by mini-css-extract-plugin
module.exports = {"container":"EnvironmentHeader__container___PIQ0J","title":"EnvironmentHeader__title___K2qBB","description":"EnvironmentHeader__description___YkBup"};